import React from "react";

const EventNotes = ({ textAreaValue, onChange }) => {
    return (
        <div
            style={{
                padding: 20,
            }}
        >
            <textarea
                rows="5"
                cols="50"
                style={{
                    width: "100%",
                    padding: "9px 11px",
                    fontSize: "12px",
                    color: "#000",
                }}
                value={textAreaValue}
                onChange={onChange}
            />
        </div>
    );
};

export default EventNotes;
